export const LOGOUT_TIMEOUT = 900000;
export const LOGOUT_WARNING_TIMEOUT = 840000;
export const HEARTBEAT_FREQUENCY = 60000;
